var map = {
	"./0categorias-capas/atualidades-e-negocios/3.jpg": [
		169,
		2
	],
	"./0categorias-capas/celebridades-e-tv/3.jpg": [
		170,
		5
	],
	"./0categorias-capas/criancas-e-quadrinhos/3.jpg": [
		171,
		8
	],
	"./0categorias-capas/decoracao-e-jardinagem/3.jpg": [
		172,
		11
	],
	"./0categorias-capas/especializadas/3.jpg": [
		173,
		14
	],
	"./0categorias-capas/esportes/3.jpg": [
		174,
		17
	],
	"./0categorias-capas/estilo-de-vida-e-moda/3.jpg": [
		175,
		20
	],
	"./0categorias-capas/games-e-tecnologia/3.jpg": [
		176,
		23
	],
	"./0categorias-capas/gastronomia-e-receitas/3.jpg": [
		177,
		26
	],
	"./0categorias-capas/historia-e-educacao/3.jpg": [
		178,
		29
	],
	"./0categorias-capas/saude-e-bem-estar/3.jpg": [
		179,
		32
	],
	"./0categorias-capas/viagens-e-lazer/3.jpg": [
		180,
		35
	],
	"./almanaque-da-saude/3.jpg": [
		664,
		41
	],
	"./ana-maria/3.jpg": [
		665,
		44
	],
	"./arte-em-festas-infantis/3.jpg": [
		666,
		47
	],
	"./arte-em-patchwork/3.jpg": [
		667,
		50
	],
	"./auto-esporte/3.jpg": [
		668,
		53
	],
	"./aventuras-na-historia/3.jpg": [
		669,
		56
	],
	"./bichos-em-casa/3.jpg": [
		670,
		59
	],
	"./bicycling/3.jpg": [
		671,
		62
	],
	"./bons-fluidos/3.jpg": [
		672,
		65
	],
	"./caras/3.jpg": [
		673,
		68
	],
	"./carros-classicos-e-cia/3.jpg": [
		674,
		71
	],
	"./casa-&-ambiente-banheiros-&-lavabos/3.jpg": [
		675,
		74
	],
	"./casa-&-ambiente-bebes/3.jpg": [
		676,
		77
	],
	"./casa-&-ambiente-quartos-e-closets/3.jpg": [
		677,
		80
	],
	"./casa-&-ambiente-salas-&-livings/3.jpg": [
		678,
		83
	],
	"./casa-&-cozinhas-e-salas-de-almoco/3.jpg": [
		679,
		86
	],
	"./casa-&-decoracao/3.jpg": [
		680,
		89
	],
	"./casa-e-jardim/3.jpg": [
		681,
		92
	],
	"./casa-interiores-&-paisagismo/3.jpg": [
		682,
		95
	],
	"./casa-vogue/3.jpg": [
		683,
		98
	],
	"./casas-pequenas/3.jpg": [
		684,
		101
	],
	"./colecao-almanaque-saude/3.jpg": [
		685,
		104
	],
	"./conceito-av-noivas/3.jpg": [
		687,
		107
	],
	"./conceito-av/3.jpg": [
		686,
		110
	],
	"./conhecimento-pratico-lingua-portuguesa/3.jpg": [
		688,
		113
	],
	"./contigo-novelas/3.jpg": [
		690,
		116
	],
	"./contigo/3.jpg": [
		689,
		119
	],
	"./crescer/3.jpg": [
		691,
		122
	],
	"./decoracao-&-estilo-casa/3.jpg": [
		692,
		125
	],
	"./decoracao-e-estilo-festas/3.jpg": [
		693,
		128
	],
	"./decorando-albuns-scrapbooking/3.jpg": [
		694,
		131
	],
	"./dinheiro-rural/3.jpg": [
		695,
		134
	],
	"./disney-historias/3.jpg": [
		696,
		137
	],
	"./epoca-negocios/3.jpg": [
		698,
		140
	],
	"./epoca/3.jpg": [
		697,
		143
	],
	"./espresso/3.jpg": [
		699,
		146
	],
	"./figurino-noivas/3.jpg": [
		700,
		149
	],
	"./filosofia-ciencia-&-vida/3.jpg": [
		701,
		152
	],
	"./fotografe-melhor/3.jpg": [
		702,
		155
	],
	"./fusca-e-cia-especial/3.jpg": [
		704,
		158
	],
	"./fusca-e-cia/3.jpg": [
		703,
		161
	],
	"./galileu/3.jpg": [
		705,
		164
	],
	"./gestao-&-negocios/3.jpg": [
		706,
		167
	],
	"./glamour/3.jpg": [
		707,
		170
	],
	"./globo-rural/3.jpg": [
		708,
		173
	],
	"./go-outside/3.jpg": [
		709,
		176
	],
	"./gq/3.jpg": [
		710,
		179
	],
	"./guia-artesanato/3.jpg": [
		711,
		182
	],
	"./guia-astral/3.jpg": [
		712,
		185
	],
	"./guia-conhecer-fantastico/3.jpg": [
		713,
		188
	],
	"./guia-curso-de-desenho/3.jpg": [
		714,
		191
	],
	"./guia-da-cozinha-festa/3.jpg": [
		715,
		194
	],
	"./guia-da-tv/3.jpg": [
		716,
		197
	],
	"./guia-de-cifras-musicais/3.jpg": [
		717,
		200
	],
	"./guia-de-cozinha/3.jpg": [
		718,
		203
	],
	"./guia-de-culinaria/3.jpg": [
		719,
		206
	],
	"./guia-de-decoracao/3.jpg": [
		720,
		209
	],
	"./guia-de-guerras/3.jpg": [
		721,
		212
	],
	"./guia-de-receitas-saudaveis/3.jpg": [
		723,
		215
	],
	"./guia-de-receitas/3.jpg": [
		722,
		218
	],
	"./guia-de-tecnologia/3.jpg": [
		724,
		221
	],
	"./guia-lazer-e-turismo/3.jpg": [
		725,
		224
	],
	"./guia-minha-saude/3.jpg": [
		726,
		227
	],
	"./guia-play-games/3.jpg": [
		727,
		230
	],
	"./guia-pratico-do-professor-educacao-infantil/3.jpg": [
		728,
		233
	],
	"./hardcore/3.jpg": [
		729,
		236
	],
	"./historia-em-foco/3.jpg": [
		730,
		239
	],
	"./historias-infantis/3.jpg": [
		731,
		242
	],
	"./hit/3.jpg": [
		732,
		245
	],
	"./humanitas/3.jpg": [
		733,
		248
	],
	"./istoe-dinheiro/3.jpg": [
		735,
		250
	],
	"./istoe/3.jpg": [
		734,
		253
	],
	"./ladybug-historias/3.jpg": [
		736,
		256
	],
	"./leituras-da-historia/3.jpg": [
		737,
		259
	],
	"./locaweb/3.jpg": [
		738,
		262
	],
	"./lucre-com-arte/3.jpg": [
		739,
		265
	],
	"./malu/3.jpg": [
		740,
		268
	],
	"./manequim/3.jpg": [
		741,
		271
	],
	"./marie-claire/3.jpg": [
		742,
		274
	],
	"./masha-e-o-urso-historias/3.jpg": [
		743,
		277
	],
	"./maxima-receitas/3.jpg": [
		744,
		280
	],
	"./mente-curiosa/3.jpg": [
		745,
		283
	],
	"./meu-proprio-negocio/3.jpg": [
		746,
		286
	],
	"./minecraft-quadrinhos/3.jpg": [
		747,
		289
	],
	"./minha-novela/3.jpg": [
		748,
		292
	],
	"./moda-moldes/3.jpg": [
		749,
		295
	],
	"./motor-show/3.jpg": [
		750,
		298
	],
	"./mundo-dos-super-herois/3.jpg": [
		751,
		301
	],
	"./mundo-em-foco/3.jpg": [
		752,
		304
	],
	"./natureza/3.jpg": [
		753,
		307
	],
	"./o-pequeno-ninja/3.jpg": [
		754,
		310
	],
	"./o-poder-dos-alimentos/3.jpg": [
		755,
		313
	],
	"./opala-&-cia/3.jpg": [
		756,
		316
	],
	"./patrulha-canina-livro-de-historia/3.jpg": [
		757,
		319
	],
	"./pegn/3.jpg": [
		758,
		322
	],
	"./peppa-pig/3.jpg": [
		759,
		325
	],
	"./pequenos-ambientes/3.jpg": [
		760,
		328
	],
	"./personalidades/3.jpg": [
		761,
		331
	],
	"./pilates/3.jpg": [
		762,
		334
	],
	"./playstation-revista-oficial/3.jpg": [
		763,
		337
	],
	"./ponto-cruz-faca-facil/3.jpg": [
		764,
		340
	],
	"./projetos-escolares/3.jpg": [
		765,
		343
	],
	"./psique/3.jpg": [
		766,
		346
	],
	"./receitas-e-delicias-caseiras/3.jpg": [
		768,
		349
	],
	"./receitas-e-delicias/3.jpg": [
		767,
		352
	],
	"./recreio/3.jpg": [
		769,
		355
	],
	"./revista-de-culinaria/3.jpg": [
		770,
		358
	],
	"./revista-oficial-xbox/3.jpg": [
		771,
		361
	],
	"./rolling-stone-edicao-especial/3.jpg": [
		773,
		364
	],
	"./rolling-stone/3.jpg": [
		772,
		367
	],
	"./runners/3.jpg": [
		774,
		370
	],
	"./salmos-e-anjos/3.jpg": [
		775,
		373
	],
	"./segredos-da-mente/3.jpg": [
		776,
		376
	],
	"./selecoes/3.jpg": [
		777,
		379
	],
	"./select/3.jpg": [
		778,
		382
	],
	"./sport-life/3.jpg": [
		779,
		385
	],
	"./sportbuzz/3.jpg": [
		780,
		388
	],
	"./tititi/3.jpg": [
		781,
		391
	],
	"./tpm/3.jpg": [
		782,
		394
	],
	"./trip/3.jpg": [
		783,
		397
	],
	"./uma/3.jpg": [
		784,
		400
	],
	"./vegan-fitness/3.jpg": [
		785,
		403
	],
	"./vegetarianos/3.jpg": [
		786,
		406
	],
	"./viaje-mais-luxo/3.jpg": [
		788,
		409
	],
	"./viaje-mais/3.jpg": [
		787,
		412
	],
	"./viva-bem/3.jpg": [
		789,
		415
	],
	"./viva-saude/3.jpg": [
		790,
		418
	],
	"./vogue/3.jpg": [
		791,
		421
	],
	"./womens-health/3.jpg": [
		792,
		424
	],
	"./yoga/3.jpg": [
		793,
		427
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 207;
module.exports = webpackAsyncContext;